import React from 'react';
import { Button } from '@mui/material';
import CheckSharp from '@mui/icons-material/CheckSharp';

export default function SendButton({ onClick, disabled = false }) {
  const click = (e) => {
    if (onClick) {
      onClick(e);
    }
  };

  return (
    <Button
      component="label"
      variant="contained"
      startIcon={< CheckSharp/>}
      disabled={disabled}
      sx={{
        mb: 1,
        backgroundColor: '#94C940',
        color: 'white',
        borderRadius: '8px',
        px: 3,
        py: 0,
        fontWeight: '1000',
        fontFamily: 'Anek Latin',
        fontSize: '1.4rem',
        textTransform: 'uppercase',
        '&:hover': {
          backgroundColor: '#94C940',
        }
      }}
        onClick={click}
    >
      Get A Quote
    </Button>
  );
}
